(function ($) {

  $.fn.SelectStyle = function () {

    this.each(function (index, element) {

      let $this = $(element),
        numberOfOptions = $this.children('option').length;

      $this.addClass('c-field__select_d-none');
      $this.wrap('<div class="c-field__select_wrap"></div>');
      $this.after('<div class="c-field__select_styled" tabindex="0"></div>');

      let $styledSelect = $this.next('div.c-field__select_styled');

      $styledSelect.text($this.children('option').eq(0).text());

      let $list = $('<ul />', {
        'class': 'c-field__select_options'
      }).insertAfter($styledSelect);

      for (var i = 0; i < numberOfOptions; i++) {

        $('<li />', {
          text: $this.children('option').eq(i).text(),
          rel: $this.children('option').eq(i).val() !== '' ? $this.children('option').eq(i).val() : 'hide',
          class: 'c-field__select_item',
          tabindex: '0'
        }).appendTo($list);

        if ($this.children('option').eq(i).is(':selected') || $this.children('option').eq(i).val() === $this.val()) {
          $('li[rel="' + $this.children('option').eq(i).val() + '"]').addClass('c-field__select_selected');
        }
      }

      if ($this.val() !== '') {
        $styledSelect.text($('option:selected', $this).text());
      } else {
        $styledSelect.addClass('c-field__select_styled-default');
      }

      $('[rel="hide"]', $list).addClass('c-field__select_d-none');

      let $listItems = $list.children('li');

      $styledSelect.on('click keydown', function (e) {
        e.stopPropagation();
        if (e.type === 'keydown') {
          if (e.keyCode === 32 || e.keyCode === 13) {
            e.preventDefault();
            $('div.c-field__select_styled.c-field__select_active').not(this).each(function () {
              $(this).removeClass('c-field__select_active').next('.c-field__select_options').hide();
            });

            $(this).toggleClass('c-field__select_active').next('.c-field__select_options').toggle();
          }
        } else if (e.type === 'click') {
          $('div.c-field__select_styled.c-field__select_active').not(this).each(function () {
            $(this).removeClass('c-field__select_active').next('.c-field__select_options').hide();
          });

          $(this).toggleClass('c-field__select_active').next('.c-field__select_options').toggle();
        }
      });

      $listItems.on('click keydown', function (e) {
        e.stopPropagation();
        if (e.type === 'keydown') {
          if (e.keyCode === 32 || e.keyCode === 13) {
            e.preventDefault();
            $styledSelect.text($(this).text()).removeClass('c-field__select_active').removeClass('c-field__select_styled-default');
            $this.val($(this).attr('rel'));
            let id = $this.attr('id');
            document.getElementById(id).dispatchEvent(new Event("change"));
            $listItems.removeClass('c-field__select_item-selected');
            $(e.target).addClass('c-field__select_item-selected');
            $list.hide();
          }
        } else if (e.type === 'click') {
          $styledSelect.text($(this).text()).removeClass('c-field__select_active').removeClass('c-field__select_styled-default');
          $this.val($(this).attr('rel'));
          let id = $this.attr('id');
          document.getElementById(id).dispatchEvent(new Event("change"));
          $listItems.removeClass('c-field__select_item-selected');
          $(e.target).addClass('c-field__select_item-selected');
          $list.hide();
        }
      });

      $(document).on('click', function () {

        $styledSelect.removeClass('c-field__select_active');
        $list.hide();

      });
    });
  };
})(jQuery);


for (var shop = "", customeremail = "", customerid = "", scripts = document.getElementsByTagName("script"), i = 0, l = scripts.length; i < l; i++) null != scripts[i].getAttribute("data-shop-id") && (shop = scripts[i].getAttribute("data-shop-id"), customerid = scripts[i].getAttribute("data-customer-id"), customeremail = scripts[i].getAttribute("data-customer-email"));

let countRequest = 0;

const guestCart = JSON.parse(localStorage.getItem('guestCart')) ?? [];

function renderPrice(discountObject, context, quantity, oldQty, basePrice) {

  let priceBlock = context.closest('.favorite-item__info').querySelector('.favorite-item__info .zprice'),
    newElement = priceBlock.querySelector('.favorite-item__crossed') ? priceBlock.querySelector('.favorite-item__crossed') : document.createElement('s'),
    newPrice = 0;

  newElement.classList.add('favorite-item__crossed');

  if (typeof discountObject.compare !== 'undefined') {
    newPrice = '$' + Number.parseFloat(discountObject.discount).toFixed(2);
    newElement.textContent = basePrice;
    priceBlock.prepend(newElement);

    if (Number.parseFloat(basePrice.replace('$', '')) === Number.parseFloat(newPrice.replace('$', ''))) {
      priceBlock.querySelector('.favorite-item__crossed').remove();
    }

  } else {

    newPrice = '$' + Number.parseFloat(discountObject.discount).toFixed(2);
    if (Number.parseFloat(discountObject.nextDiscount) !== Number.parseFloat(basePrice.replace('$', ''))) {
      newPrice += ' EACH ';
      if (Number.parseInt(discountObject.nextFrom) > Number.parseInt(quantity) && (window.customer.group.toLowerCase() === 'retail' || window.customer.group.toLowerCase() === 'retail - cco' || window.customer.group.toLowerCase() === 'retail - cbd')) {
        newPrice += '(<span>' + discountObject.nextFrom + '</span>+ FOR ' + '$' + Number.parseFloat(discountObject.nextDiscount).toFixed(2) + ')';
      }
    }

    if (Number.parseFloat(discountObject.discount) < Number.parseFloat(basePrice.replace('$', ''))) {
      newElement.textContent = basePrice;
      newPrice = newElement.outerHTML + newPrice;
    }

    priceBlock.innerHTML = newPrice;
  }

}

function checkoutDiscount(quantity, discount, context, oldQty = null, basePrice) {

  let result = {},
    sortDiscount = discount.sort(function (a, b) {
      let aDE = a.split('-'),
        bDE = b.split('-');
      return Number.parseInt(aDE[0]) - Number.parseInt(bDE[0]);
    });

  for (let i = 0; i < sortDiscount.length; i++) {
    if (typeof sortDiscount[i + 1] === 'undefined') {
      let arrayDiscounts = sortDiscount[i].split('-');
      if (Number.parseInt(quantity) >= Number.parseInt(arrayDiscounts[0])) {
        result.from = arrayDiscounts[0];
        result.to = 'infinity';
        result.discount = arrayDiscounts[1];
        result.nextFrom = arrayDiscounts[0];
        result.nextDiscount = arrayDiscounts[1];
        break;
      }
    } else {
      let arrayDiscounts = sortDiscount[i].split('-'),
        arrayNextDiscounts = sortDiscount[i + 1].split('-');
      if (Number.parseInt(quantity) >= Number.parseInt(arrayDiscounts[0]) && Number.parseInt(quantity) < Number.parseInt(arrayNextDiscounts[0])) {
        result.from = arrayDiscounts[0];
        result.to = arrayNextDiscounts[0];
        result.discount = arrayDiscounts[1];
        result.nextFrom = arrayNextDiscounts[0];
        result.nextDiscount = arrayNextDiscounts[1];
        break;
      }
    }
  }
  renderPrice(result, context, quantity, oldQty, basePrice);
}

function findDiscount(customerGroup, tags, productId) {
  if (typeof tags.find(el => el === 'tiered-pricing') !== 'undefined') {
    return tags.map(function (tag) {
      if (tag !== 'tiered-pricing') {
        let chunksTag = tag.split(':');
        if (
          (chunksTag[1] && chunksTag[1].toLowerCase() === customerGroup.toLowerCase() && chunksTag[0] === 'discount' && Number.parseInt(chunksTag[2]) === Number.parseInt(productId)) ||
          (chunksTag[1] && chunksTag[1].toLowerCase() === customerGroup.toLowerCase() && chunksTag[0] === 'discount' && chunksTag[2] === 'product')
        ) {
          return chunksTag.slice(3);
        }
      }
    });
  }
  return null;
}

function getProductVariant(idVariant, handler, count, counter, tags, basePrice) {

  let url = typeof idVariant !== 'undefined' ?
    "/products/" + handler + "?variant=" + idVariant + "&view=meta" :
    "/products/" + handler + "?view=meta";
  $.ajax({
    url: url,
    success: function (data) {

      if (counter && countRequest === 0) {
        countRequest = counter;
      }

      if (count && countRequest > 1) {
        countRequest -= 1;
      }

      let answer = JSON.parse(data),
        compare = null,
        hiddenSelect = document.getElementById('zooomyshopvariant-' + answer.productId);

      const productEl = document.getElementById("favorite-item-" + answer.productId);

      let variantSelectedId = answer.productVariantId && typeof idVariant !== 'undefined' ?
        answer.productVariantId :
        Number.parseInt(hiddenSelect.querySelector('option:checked').dataset['id']);

      if (answer.inventoryQuantity === 0) {
        $(productEl).find(".btn_default").addClass("btn_disabled").text('Out of Stock');
      }

      if (answer.collection_url) {
        $(productEl).find("a").each(function () {
          if ($(this).attr('href').indexOf(answer.collection_url) === -1) {
            $(this).attr('href', answer.collection_url + $(this).attr('href'));
          }
        })
      }

      let isBackorder = false;

      if (answer.inventoryPolicy === 'continue') {
        isBackorder = true;
      }

      if (productEl) {

        const infoEl = productEl.querySelector('.zbodyinfo'),
          addButton = document.getElementById(answer.productId),
          badgeOutOfStock = document.createElement('div'),
          qtyInput = document.getElementById('zqtyn-' + answer.productId);

        let discount = [];

        badgeOutOfStock.classList.add('favorite-item__error');
        qtyInput.value = 1;

        if (answer.productId === variantSelectedId && answer.compareProduct) {
          compare = answer.compareProduct;
        } else if (answer.productId !== variantSelectedId && answer.compareProductVariant) {
          compare = answer.compareProductVariant;
        }

        if (tags && tags.length > 0) {

          let customerGroup = window.customer.group;

          if (typeof idVariant !== 'undefined') {
            discount = findDiscount(customerGroup, tags, idVariant).filter(Boolean);
          } else {
            discount = findDiscount(customerGroup, tags, variantSelectedId).filter(Boolean);
          }

          if (discount.length > 0) {

            checkoutDiscount(qtyInput.value, discount[0], infoEl, null, basePrice);

            let buttonsQty = qtyInput.parentNode.querySelectorAll('button'),
              oldValue = Number.parseInt(qtyInput.value);

            $(buttonsQty).on('click.discount', function () {
              if ($(this).attr('name') === 'plus') {
                oldValue += 1;
              } else {
                oldValue -= 1;
              }
            });

            $(qtyInput).off('change.discount');
            $(qtyInput).on('change.discount', function () {
              checkoutDiscount(this.value, discount[0], infoEl, oldValue, basePrice);
            });
          } else {
            $(qtyInput).off('change.discount');
          }
        }

        if (discount.length === 0 && compare) {
          renderPrice({"compare": compare});
        }

        let globalOosLabel;
        let soldOutText = 'Out of Stock';

        if (isBackorder) {
          if (answer.outOfStockCommonBackorder !== '') {
            globalOosLabel = answer.outOfStockCommonBackorder;
          } else {
            globalOosLabel = soldOutText;
          }
        } else {
          if (answer.outOfStockCommon !== '') {
            globalOosLabel = answer.outOfStockCommon;
          } else {
            globalOosLabel = soldOutText;
          }
        }

        if (answer.productVariantsSize === 1 && answer.inventoryQuantity < 1) {
          if (answer.productMeta && answer.productMeta.out_of_stock !== '') {
            badgeOutOfStock.textContent = answer.productMeta.out_of_stock;
          } else {
            badgeOutOfStock.textContent = globalOosLabel;
          }
        } else if (answer.productVariantsSize !== 1 && answer.inventoryQuantity < 1) {
          if (answer.variantMeta && answer.variantMeta.out_of_stock !== '') {
            badgeOutOfStock.textContent = answer.variantMeta.out_of_stock;
          } else {
            badgeOutOfStock.textContent = globalOosLabel;
          }
        }

        if (handler !== 'gift-card') {
          if (badgeOutOfStock.textContent !== '' && infoEl.querySelector('.favorite-item__error') === null) {
            infoEl.append(badgeOutOfStock);
          } else if (badgeOutOfStock.textContent === '' && infoEl.querySelector('.favorite-item__error') !== null) {
            infoEl.querySelector('.favorite-item__error').remove();
          }

          if (answer.inventoryQuantity < 1 && isBackorder === false) {
            addButton.textContent = 'out of stock';
            disableAddButton(addButton);
          } else if (answer.inventoryQuantity < 1 && isBackorder) {
            addButton.textContent = 'backorder';
            enableAddButton(addButton);
          } else {
            addButton.textContent = 'add to cart';
            enableAddButton(addButton);
          }
        }
      }
      if (countRequest === 1 && guestCart.length === 0) {
        let selects = $("[data-custom-select-favorite]"),
          selectsForRender = [];

        selects.each(function () {
          let childrenFirst = $(this).children().first();

          if (typeof childrenFirst !== 'undefined' && childrenFirst.text() !== 'undefined' && $(this).siblings('.c-field__select_options').children().length === 0) {
            selectsForRender.push($(this));
          }
        });

        if (selectsForRender.length > 0) {
          $(selectsForRender).SelectStyle();
        }

        $('.s-account').removeClass('is-loaded').removeClass('is-loaded-overview');
      }

      function disableAddButton(addButton) {
        addButton.setAttribute('disabled', 'disabled');
        addButton.classList.add('btn_disabled');
      }

      function enableAddButton(addButton) {
        addButton.removeAttribute('disabled');
        addButton.classList.remove('btn_disabled');
      }
    }
  });
}

function ZooomyDataFun(e, t, customeremail) {
  let zooomListUrl = "https://zooomyapps.com/wishlist/api/frontend/";
  let rootIs = Shopify.routes.root;
  let prIdsForAll = "";
  $.ajax({
    url: zooomListUrl + 'wishlist',
    method: 'post',
    data: {
      shop: e,
      customerid: t,
      lang: rootIs
    },
    dataType: "json",
    async: "true",
    success: function (n) {
      document.body.classList.add('wishlist-is-loaded');
      var i = n.custom_css,
        o = n.user_added_css,
        r = n.id,
        a = n.product_id,
        s = (n.product_price, n.product_handle),
        l = n.product_name,
        c = n.product_img,
        u = n.wishlist_page_product_text,
        d = n.wishlist_page_product_text_bg,
        p = n.wishlist_page_product_text_f_color,
        f = n.wishlist_page_add_cart_text,
        h = n.wishlist_page_add_cart_text_f_color,
        m = n.wishlist_page_add_cart_text_bg,
        g = n.remove_from_wishlist,
        y = n.remove_from_wishlist_f_color,
        v = n.remove_from_wishlist_bg,
        b = n.layout,
        x = getCurrencySymbol(Shopify.currency.active), //n.shop_currency,
        w = n.shop_name,
        T = n.sold_out_text,
        C = n.directdelete,
        k = n.cus_email,
        E = n.zemail_e_btn,
        N = n.zemail_textarea,
        _ = n.zemail_s_btn,
        S = n.frnd_name,
        z = n.frnd_email,
        j = n.frnd_name_bg,
        A = n.frnd_name_f_color,
        D = n.variant_name,
        L = n.empty_text,
        P = n.plan,
        W = (s = n.product_handle, "qyghbced" + t + "azhu607h"),
        H = n.savdatawp;
      f = (f = (f = (f = (f = (f = f.replace("&Oslash;", "Ø")).replace("&Aring;", "Å")).replace("&AElig;", "Æ")).replace("&oslash;", "ø")).replace("&aring;", "å")).replace("&aElig;", "æ"), u = (u = (u = (u = (u = (u = u.replace("&Oslash;", "Ø")).replace("&Aring;", "Å")).replace("&AElig;", "Æ")).replace("&oslash;", "ø")).replace("&aring;", "å")).replace("&aElig;", "æ"), g = (g = (g = (g = (g = (g = g.replace("&Oslash;", "Ø")).replace("&Aring;", "Å")).replace("&AElig;", "Æ")).replace("&oslash;", "ø")).replace("&aring;", "å")).replace("&aElig;", "æ");
      var q = [];
      if ("" == t)
        if ("yes" == n.w_login) {
          $("#ZoomyWishlistPage").append("<a href='https://" + w + "/account/login' target='_blank' class='zmsg'>" + n.login_save + "</a>");
          var O = [],
            F = [],
            M = [],
            B = [],
            Z = [],
            I = [];
          if (null == localStorage.getItem("myzooomy__wishlist")) ;
          else {
            var R = "",
              X = localStorage.getItem("myzooomy__wishlist");
            q = JSON.parse(X), $.each(q, function (e, t) {
              O.push(t.product_id), F.push(t.product_handle), B.push(t.proprice), M.push(t.protitle), Z.push(t.proimage), I.push(t.vname)
            })
          }
          r = O, a = O, s = F, l = M, c = Z, D = I
        } else $("#ZoomyWishlistPage").append("<a href='https://" + w + "/account/login' target='_blank' class='zmsg'>" + n.login_text + "</a>");
      if (a !== null) {

        $('<link rel="stylesheet" type="text/css" href="https://zooomyapps.com/wishlist/WishlistStyle.css">').appendTo("body"), $("<style>" + i + "</style>").appendTo("body"), $("<style></style>").appendTo("body"), $("<style></style>").appendTo("body"), $("<style></style>").appendTo("body"), $("<style></style>").appendTo("body"), "false" != k && "" != t || $("<style>#zooomyemailfbtn{display:none;}</style>").appendTo("body"), $("<style>.ZoomyWishlistPagecol li{float:left; width:25%; box-sizing:border:box; padding:10px; }.ZoomyWishlistPagecol{float: left; width: 100%;margin-bottom:10px; border-bottom:1px solid #ededed;}</style>").appendTo("body"), 0 != a && "0" != a && null != a && "null" != a || ("no" == n.w_login ? "" != t && (0 == $(".zmsg").length ? $("#ZoomyWishlistPage").append("<p class='zmsg s-account__history-empty'>It is empty here. <br>Personalize your shopping experience with your Favorites. <a class='s-account__history-empt-link' href='/'>Shop Now</a></p>") : $("#ZoomyWishlistPage .zmsg").replaceWith("<p class='zmsg s-account__history-empty'>It is empty here. <br>Personalize your shopping experience with your Favorites. <a class='s-account__history-empt-link' href='/'>Shop Now</a></p>")) : $("#ZoomyWishlistPage").append("<p class='zmsg s-account__history-empty'>It is empty here. <br>Personalize your shopping experience with your Favorites. <a class='s-account__history-empt-link' href='/'>Shop Now</a></p>"), $("<style>.ZoomyWishlistPagecol{display:none;}</style>").appendTo("body")), $("#ZoomyWishlistPage").before("<span class='zooomyaddtowishlistmsg' style='float:left;width:100%;'></span>"), "nfree" == P && "free" == P || ($("#ZoomyWishlistPage").before("<span class='zooomybtn' id='zooomyemailfbtn' style='cursor:pointer;border: none;float:left; width:100%;'><a id='emailzwishlist' class='' style='background:" + j + "; color:" + A + ";'>" + E + "</a></span>"), $("#ZoomyWishlistPage").before("<div id='zemaildata' style='display:none;'><form><input type='text' id='zemailname'  placeholder='" + S + "' required/><input type='email' id='zemailid'   placeholder='" + z + "'  required/><textarea id='zemailmsg' required> " + N + " </textarea><a id='zsendemail'>" + _ + "</a></form></div>"), 1 != k && "true" != k || $(".zooomybtn").append('<div class="z_social_share_wishlist"><a class="zooomylink_fa"><i class = "fa fa-link"></i></a><a class="zsocial_icon" href="https://www.facebook.com/sharer/sharer.php?u=https://' + w + "/pages/share-wish-list?" + W + '&t=Wishlist" onclick="javascript:window.open(this.href, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600");return false;" target="_blank" title="Share on Facebook"><i class="fa fa-facebook"></i><a href="https://twitter.com/share?url=https://' + w + "/pages/share-wish-list?" + W + '&text=Share Wishlist" onclick="javascript:window.open(this.href, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600");return false;" target="_blank" title="Share on Twitter"><i class="fa fa-twitter"></i></a><a href="http://pinterest.com/pin/create/button/?url=https://' + w + "/pages/share-wish-list?" + W + '&media=" onClick="javascript:window.open(this.href, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600");return false;" target="_blank" title="Share on Pinterest"><i class="fa fa-pinterest"></i></a><a href="whatsapp://send?text=https://' + w + "/pages/share-wish-list?" + W + '" data-action="share/whatsapp/share" onClick="javascript:window.open(this.href, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600");return false;" target="_blank" title="Share on whatsapp"><i class="fa fa-whatsapp"></i></a><a href="mailto:?subject=' + S + "&body=" + N + ": https://" + w + "/pages/share-wish-list?" + W + '" onClick="javascript:window.open(this.href, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600");return false;" target="_blank" title="Share on Mail"><i class="fa fa-envelope"></i></a></div>'), $("<style> .z_social_share_wishlist .fa{background:" + j + "; color:" + A + ";border:none;}</style>").appendTo("body"), $("#ZoomyWishlistPage").before("<textarea id='zooomycopytxtarea'  style='display:none;margin:10px 0;float: left; width: 100%; text-align: center; padding: 10px; height: 58px; min-height: 20px; border: 1px solid #eee; font-size: 18px; color: #888;'>https://" + w + "/pages/share-wish-list?" + W + "</textarea>")), $("<style> #zsendemail{background:" + j + "; color:" + A + ";border:none;}</style>").appendTo("body"), "list" == b && $("#ZoomyWishlistPage").addClass("zooomywishlistlistclass"), $("<style>.ZoomyWishlistPageGrid span.zooomybtn { cursor:pointer;border: none; margin: 2px; padding: 4px 10px; margin-top: 20px; box-sizing: border-box; }.ZoomyWishlistPageGrid{float: left; width: 31.3%; box-sizing: border-box; position: relative; text-align: center; margin: 10px 1%; border: 1px solid #efefef; padding: 20px;}</style>").appendTo("body"), $("<style></style>").appendTo("body"), $.each(r, function (i, o) {
          $("#ZoomyWishlistPage").append("<div class='ZoomyWishlistPageGrid' id='ZoomyWishlistPageGrid-" + a[i] + "'> <div id='favorite-item-" + a[i] + "' class='favorite-item'> <div class='favorite-item__left'> <div class='favorite-item__img'> <div class='zbodypimg'><a target='_blank' title='" + l[i] + "' href='" + "/products/" + s[i] + "'><img src='" + c[i] + "' alt='" + unescapeHtml(l[i]) + "' width='100' aria-hidden='true'></a></div></div> <div class='favorite-item__info'> <div class='zbodytitle'><a href='" + "/products/" + s[i] + "'>" + l[i] + "</a></div></div></div> <div class='favorite-item__right'><div class='favorite-item__action zbodyaction'></div></div></div>"), $("#ZoomyWishlistPage #ZoomyWishlistPageGrid-" + a[i] + " .zbodyaction").append("<button id='" + a[i] + "' class='zbtn zooomybtn addcartbtn btn btn_default btn_red zopencartlink' value='" + s[i] + "' data-pro-id='" + a[i] + "'>" + f + "</button>"), $("#ZoomyWishlistPage #ZoomyWishlistPageGrid-" + a[i] + " .zbodyaction").append("<button id='rmvfrmwish" + a[i] + "' class='zooomybtn removefromwishlist zremovefromwish' value='" + a[i] + "'>Remove from Favorites</button>"), $("#ZoomyWishlistPage #ZoomyWishlistPageGrid-" + a[i] + " .zbodytitle").after("<div class='zbodyinfo'><div class='zoptionbox' style='float:left;width:100%;margin:10px 0px;'>" +
            "<select style='display: none;' class='zooomyshopvariant' id='zooomyshopvariant-" + a[i] + "'></select>" +
            "<select data-custom-select-favorite style='display: none;' class='zooomyshopvariant_size' id='zooomyshopvariant_size-" + a[i] + "'></select>" +
            "<select data-custom-select-favorite style='display: none;' class='zooomyshopvariant_flavor' id='zooomyshopvariant_flavor-" + a[i] + "'></select>" +
            "</div><div class='zqty'> <span class='zqty-title'>Quantity:</span>" +
            "<quantity-input class=\"c-quantity c-quantity_row favorite-item__c-quantity\" data-line-item-key=\'" + a[i] + "'\">\n" +
            "            <button aria-label='Lower count' class=\"c-quantity__button\" name=\"minus\" type=\"button\"></button>\n" +
            "            <input id='zqtyn-" + a[i] + "' class=\"c-quantity__input c-quantity__input_font-monserat\" aria-label='Count'  type=\"number\"  name=\"updates[]\"  value=\"1\"  min=\"1\"  size=\"2\"  id=\"Quantity-'+ a[i] + '\"  data-index=\'" + a[i] + "'>\n" +
            "            <button aria-label='Add count' class=\"c-quantity__button\" name=\"plus\" type=\"button\"></button>\n" +
            "          </quantity-input></div></div></div>");
          var r = "https://" + n.shop_name + "/cart";
          var handler = s[i];
          $.ajax({
            url: "/products/" + s[i] + ".js",
            dataType: "json",
            success: function (o) {
              let tags = o.tags;
              var s = o.price;
              if (null == (l = o.variants.available)) var l = o.available;
              if (0 == l) {
                $("button#" + a[i]).text(T);
                $("button#" + a[i]).addClass("z_w_soldout btn_disabled");
                $("#favorite-item-" + a[i] + " .zqty").hide();
              } else {
                $("button#" + a[i]).text(f);
                $("button#" + a[i]).removeClass("z_w_soldout btn_disabled");
              }
              s = (s /= 100).toFixed(2);
              if ("jens-gullsmidur.myshopify.com" == w) {
                s *= 100;
              }
              if ("hello-sasha.myshopify.com" == w) {
                s += x;
              } else {
                s = x + s;
              }
              $("#ZoomyWishlistPageGrid-" + a[i] + " .zbodytitle").after("<span class='zprice' style='float:left; width:100%;'>" + s + "</span>");
              let varintsAvailable = true;
              $(o.variants).each(function (e, t) {
                var n = t.title,
                  optFlavor = n.split(' / ')[1],
                  optSize = n.split(' / ')[0];

                null == t.featured_image ? vimg = "" : vimg = t.featured_image.src, $("#zooomyshopvariant-" + a[i]).append("<option id='" + t.id + "'  data-id='" + t.id + "'  value='" + t.title + "'  data-image='" + vimg + "' data-price='" + t.price + "'  data-available='" + t.available + "' >" + t.title + "</option>"), $("#zooomyshopvariant_size-" + a[i] + ' option[value="' + optSize + '"]').length === 0 ? $("#zooomyshopvariant_size-" + a[i]).append("<option value='" + optSize + "'>" + optSize + "</option>") : null, $("#zooomyshopvariant_flavor-" + a[i] + ' option[value="' + optFlavor + '"]').length === 0 ? $("#zooomyshopvariant_flavor-" + a[i]).append("<option value='" + optFlavor + "'>" + optFlavor + "</option>") : null, "Default Title" == n && $("#ZoomyWishlistPage #ZoomyWishlistPageGrid-" + a[i] + " .zoptionbox").hide();

                var o = $("#zooomyshopvariant-" + a[i]);
                o.find("option:selected").text();
                "false" == o.find("option:selected").attr("data-available") ? ($("button#" + a[i]).text(T), $("button#" + a[i]).addClass("z_w_soldout btn_disabled")) : ($("button#" + a[i]).text(f), $("button#" + a[i]).removeClass("z_w_soldout btn_disabled"));
                
                if (t.available && varintsAvailable) {
                  prIdsForAll = [...prIdsForAll, {"id": t.id, "quantity": 1}];
                  varintsAvailable = false;
                }
              });
              D[i] = D[i].trim();
              if ("" != D[i]) {
                $("#zooomyshopvariant-" + a[i]).val(D[i]);
                var c = $("#zooomyshopvariant-" + a[i]),
                  u = (c.find("option:selected").text(), c.find("option:selected").attr("data-image")),
                  d = c.find("option:selected").attr("data-price"),
                  id = c.find("option:selected").attr("data-id"),
                  p = c.find("option:selected").attr("data-available");
                "false" == p ? ($("button#" + a[i]).text(T), $("button#" + a[i]).addClass("z_w_soldout btn_disabled")) : ($("button#" + a[i]).text(f), $("button#" + a[i]).removeClass("z_w_soldout btn_disabled")), "" != u && $("#ZoomyWishlistPageGrid-" + a[i] + " .zbodypimg img").attr("src", u), d = (d /= 100).toFixed(2), "hello-sasha.myshopify.com" == w ? d += x : d = x + d, null == d || "$NaN" == d || $("#ZoomyWishlistPageGrid-" + a[i] + " .zprice").replaceWith("<span class='zprice'>" + d + "</span>"), p || $("#ZoomyWishlistPageGrid-" + a[i] + " .zavailable").replaceWith("<span class='zavailable' style='float: left; width: 100%;'>" + p + "</span>")
                let optTitle = c.find("option:selected").text(),
                  optFlavor = optTitle.split(' / ')[1],
                  optSize = optTitle.split(' / ')[0],
                  startSizeFlavor = c.find("option:selected").attr('id');
                $("#zooomyshopvariant_flavor-" + a[i] + " option").text(function (idx, val) {
                  $(this).siblings('[value="' + val + '"]').remove();
                });
                $("#zooomyshopvariant_size-" + a[i] + " option").text(function (idx, val) {
                  $(this).siblings('[value="' + val + '"]').remove();
                });
                $("#zooomyshopvariant_flavor-" + a[i]).children('option[value="' + optFlavor + '"]').prop('selected', true)
                $("#zooomyshopvariant_size-" + a[i]).children('option[value="' + optSize + '"]').prop('selected', true)
              }
              "" == D[i] && $("#zooomyshopvariant-" + a[i]).val(o.variants[0].title), $("#zooomyshopvariant-" + a[i] + "  option").each(function () {
                "Default Title" == this.value && $("#zooomyshopvariant-" + a[i]).val("Default Title")
              }), $("#zooomyshopvariant-" + a[i]).change(function () {
                var n = $("#zooomyshopvariant-" + a[i]),
                  o = n.find("option:selected").text(),
                  r = n.find("option:selected").attr("data-image"),
                  s = n.find("option:selected").attr("data-price"),
                  l = n.find("option:selected").attr("data-available"),
                  c = n.find("option:selected").attr("data-id");
                getProductVariant(c, handler, i, a.length, tags, (s / 100).toFixed(2));
                let optTitle = n.find("option:selected").text(),
                  optFlavor = optTitle.split(' / ')[1],
                  optSize = optTitle.split(' / ')[0];

                "false" == l ? ($("button#" + a[i]).text(T), $("button#" + a[i]).addClass("z_w_soldout btn_disabled")) : ($("button#" + a[i]).text(f), $("button#" + a[i]).removeClass("z_w_soldout btn_disabled")), s = (s /= 100).toFixed(2), "hello-sasha.myshopify.com" == w ? s += x : s = x + s, "" != r && $("#ZoomyWishlistPageGrid-" + a[i] + " .zbodypimg img").attr("src", r), $("#ZoomyWishlistPageGrid-" + a[i] + " .zprice").replaceWith("<span class='zprice'>" + s + "</span>"), $("#ZoomyWishlistPageGrid-" + a[i] + " .zavailable").replaceWith("<span class='zavailable' style='float: left; width: 100%;'>" + l + "</span>"), "yes" == H && $.ajax({
                  url: zooomListUrl + "save-data-wishlist",
                  type: 'post',
                  data: {
                    shop: e,
                    productid: a[i],
                    customerid: t,
                    vid: c,
                    vname: o,
                    vprice: s
                  },
                  dataType: "json",
                  async: "true",
                  success: function (e) {
                    $("#ZoomyWishlistPageGrid-" + a[i] + " .zoptionbox").append("<p class='zsavdatamsg' style='font-size: 12px;  position: absolute; text-align: center; width: 100%; margin: 0; padding: 0; box-sizing: border-box; left: 4px;'>" + e.datasaved + "</p>"), setTimeout(function () {
                      $(".zsavdatamsg").fadeOut("slow")
                    }, 350)
                  }
                })
              }), $("#zooomyshopvariant_flavor-" + a[i] + " , #zooomyshopvariant_size-" + a[i]).change(function () {
                let thisSize = $("#zooomyshopvariant_size-" + a[i]).find("option:selected").val(),
                  thisFlavor = $("#zooomyshopvariant_flavor-" + a[i]).find("option:selected").val();
                if (thisSize == 'undefined') {
                  if ($("#zooomyshopvariant-" + a[i]).find('option[value="' + thisFlavor + '"]').length) {
                    $("#zooomyshopvariant-" + a[i]).find('option[value="' + thisFlavor + '"]').prop('selected', true)
                    $("#zooomyshopvariant-" + a[i]).change()
                    $("button#" + a[i]).removeClass("btn_disabled")
                  } else {
                    $("button#" + a[i]).addClass("btn_disabled")
                  }
                } else if (thisFlavor == 'undefined') {
                  if ($("#zooomyshopvariant-" + a[i]).find('option[value="' + thisSize + '"]').length) {
                    $("#zooomyshopvariant-" + a[i]).find('option[value="' + thisSize + '"]').prop('selected', true)
                    $("#zooomyshopvariant-" + a[i]).change()
                    $("button#" + a[i]).removeClass("btn_disabled")
                  } else {
                    $("button#" + a[i]).addClass("btn_disabled")
                  }
                } else {
                  if ($("#zooomyshopvariant-" + a[i]).find('option[value="' + thisSize + ' / ' + thisFlavor + '"]').length) {
                    $("#zooomyshopvariant-" + a[i]).find('option[value="' + thisSize + ' / ' + thisFlavor + '"]').prop('selected', true)
                    $("#zooomyshopvariant-" + a[i]).change()
                    $("button#" + a[i]).removeClass("btn_disabled")
                  } else {
                    $("button#" + a[i]).addClass("btn_disabled")
                  }
                }
              }), $("#ZoomyWishlistPageGrid-" + a[i] + " .addcartbtn").click(function () {
                var o = $("#zooomyshopvariant-" + a[i]);
                "" == o.find("option:selected").text() && alert("Please select value from dropdown");
                o.find("option:selected").attr("data-image"), $(this).attr("data-pro-id");
                var s = o.find("option:selected").attr("data-id"),
                  l = $("#zqtyn-" + a[i]),
                  c = (l.find("option:selected").text(), l.val());
                var hashLink = $('#select-menu').val();
                if ($(window).width() > 767) {
                  var accountVisibleContent = document.querySelector('.s-account__content_is-visible');
                  if (accountVisibleContent) {
                    hashLink = accountVisibleContent.getAttribute('id');
                  }
                }
                null == s && (s = a[i]),
                  function (e, t, n) {
                    if (null == localStorage.getItem("ZwishlistPageEmail") || "" == localStorage.getItem("ZwishlistPageEmail")) var t = t;
                    else localStorage.getItem("ZwishlistPageEmail");
                    if (localStorage.setItem("ZwishlistPageEmail", t), null == localStorage.getItem("ZwishlistPageid") || "" == localStorage.getItem("ZwishlistPageid")) var n = n;
                    else localStorage.getItem("ZwishlistPageId");
                    if (localStorage.setItem("ZwishlistPageId", n), null == localStorage.getItem("ZwishlistpageproIds")) var i = e;
                    else {
                      var o = localStorage.getItem("ZwishlistpageproIds");
                      if (o.indexOf(e) > -1) var i = e;
                      else var i = o + "," + e
                    }
                    localStorage.setItem("ZwishlistpageproIds", i)
                  }(a[i], customeremail, t), $.ajax({
                  type: "POST",
                  url: "/cart/add.js",
                  dataType: "json",
                  data: {
                    quantity: c,
                    id: s
                  },
                  success: function (o) {
                    if (window.customer && customer.free_flask && customer.free_flask.buy_ids && customer.free_flask.buy_ids.includes(s)) {
                      localStorage.setItem('_hnflask', 1);
                    }

                    $.getJSON("/cart.js", function (o) {
                      if ("true" == C) {
                        var s = a[i];
                        q = q.filter(e => e.product_id != s), $("#ZoomyWishlistPageGrid-" + a[i] + ' .favorite-item__action').append(`<div style="display: inline-flex;color: #0a8900;" class="c-field__error c-field__error_padding c-field__error_succeed c-field__error_show"><div class="c-field__error-text">Item successfully added to your cart</div><div class="c-field__close"><svg class="icon icon_close-red c-field__icon"  width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="5.5" cy="5" r="5" fill="white"/><path d="M3.90916 3.76271C3.81153 3.66508 3.81153 3.50679 3.90916 3.40916C4.00679 3.31153 4.16508 3.31153 4.26271 3.40916L7.09114 6.23759C7.18877 6.33522 7.18877 6.49351 7.09114 6.59114C6.99351 6.68877 6.83522 6.68877 6.73759 6.59114L3.90916 3.76271Z" fill="#0A8900"/><path d="M4.26292 6.59117C4.16529 6.6888 4.007 6.6888 3.90937 6.59117C3.81174 6.49354 3.81174 6.33524 3.90937 6.23761L6.73779 3.40919C6.83543 3.31156 6.99372 3.31156 7.09135 3.40919C7.18898 3.50682 7.18898 3.66511 7.09135 3.76274L4.26292 6.59117Z" fill="#0A8900"/></svg></div></div>`) , $("#zooomyitemadded").each(function () {
                          $('[id="' + this.id + '"]:gt(0)').remove()
                        });

                        window.wishListReload = true;
                        document.dispatchEvent(new CustomEvent("cartUpdate", {bubbles: true, detail: o}));
                      } else $("button#" + a[i]).replaceWith('<button id="' + a[i] + '" class="zooomybtn addcartbtn zopencartlink" value=""><a href="' + r + '" style="color:' + h + '">' + n.open_cart_text + "</a></button>"), "yes" == n.refresh_cart && location.reload()
                    })
                    if (hashLink !== undefined && hashLink !== null && hashLink !== '') {
                      window.location.hash = '#tab22';
                    }
                  }
                })
              });
              let currentPrice = typeof d === 'undefined' ? s : d;
              var cc = $("#zooomyshopvariant-" + a[i]),
                ccid = cc.find("option:selected").attr("data-id");
              getProductVariant(ccid, handler, i, a.length, tags, currentPrice);
            },
            error: function (e) {
              $("#ZoomyWishlistPage #ZoomyWishlistPageGrid-" + a[i]).hide()
              if (i && countRequest === 0) {
                countRequest = i;
              }

              if (i && countRequest > 1) {
                countRequest -= 1;
              }
            }
          })
        });
        
        // Add all to cart functionality
        if ((n.all_add_to_wishlist_status == "yes") && prIdsForAll.length > 0) {
          $(`<style>#addtocartAll{text-align: center;} .addcartbtnAll.zooomybtn{
              width:${n.all_add_to_wishlist_width_percent !== "" ? n.all_add_to_wishlist_width_percent : 'auto'};
              color:#${n.all_add_font_color};
              background-size:${n.all_add_font_size};
              background-color:#${n.all_add_background_color};
              border-color:#${n.all_add_border_color};
              border:${n.all_add_border_width};
              border-radius:${n.all_add_border_radius};
              float:none
          }</style>`).appendTo('body');

          let addtocartAll = `<div id="addtocartAll"><button class="addcartbtnAll zbtn zooomybtn zopencartlink">${n.all_add_to_wishlist_text}</button></div>`;
          $("#ZoomyWishlistPage").after(addtocartAll);
          
          $("body").on("click", ".addcartbtnAll", function () {
            let self = $(this);
            let formData = {
              'items': prIdsForAll
            };

            $.ajax({
              type: 'POST',
              url: rootIs + 'cart/add.js',
              dataType: 'json',
              data: formData,
              success: function (aItem) {
                let aItems = aItem.items;
                let cartlink = 'https://' + n.shop_name + '/cart';
                
                aItems.forEach(item => {
                  let productids = "";
                  let pid = item.product_id;

                  if (localStorage.getItem("ZwishlistproIds") == undefined) {
                    productids = pid;
                  } else {
                    let zooomywishlists = localStorage.getItem("ZwishlistproIds");
                    if (zooomywishlists.indexOf(pid) > -1) {
                      productids = pid;
                    } else {
                      productids = zooomywishlists + "," + pid;
                    }
                  }
                  localStorage.setItem("ZwishlistproIds", productids);
                  
                  if (C == "true") {
                    var wishlistid = pid;
                    q = q.filter(product => {
                      return product.product_id != wishlistid
                    });

                    $(".zooomyaddtowishlistmsg").append('<span id="zooomyitemadded"><a aria-label="Cart link" href="' + cartlink + '">' + n.open_cart_text + '</a></span>');

                    $('#zooomyitemadded').each(function () {
                      $('[id="' + this.id + '"]:gt(0)').remove();
                    });
                    
                    var addtocart = "yes";
                    $.ajax({
                      url: zooomListUrl + "remove-product",
                      data: {
                        shop: e,
                        productid: wishlistid,
                        customerid: t,
                        addtocart: addtocart
                      },
                      dataType: "json",
                      type: "post",
                      async: "true",
                      success: function (njsonData) {
                        pid = njsonData.productid;
                        $('#ZoomyWishlistPageGrid-' + pid).remove();
                        $('#ZoomyWishlistPagecol-' + pid).remove();
                      }
                    });
                    
                    myJSON = JSON.stringify(q);
                    console.log("myJSON...", myJSON);
                    localStorage.setItem("myzooomy__wishlist", myJSON);
                    
                    if ($('#zooomy-wishlist-counter').length) {
                      var wishcountval = ($('.ZoomyWishlistPageGrid').length) - 1;
                      document.getElementById("zooomy-wishlist-counter").innerHTML = "<span>" + wishcountval + "</span>";
                    }
                  } else {
                    console.log("wishlistid...", pid);
                    $("button#" + pid).replaceWith('<button id="' + pid + '" class="zooomybtn addcartbtn zopencartlink" value=""><a aria-label="Cart link" href="' + cartlink + '" style="color:' + h + '">' + n.open_cart_text + '</a></button>');
                    self.text(n.open_cart_text);
                  }
                });
                
                if (n.refresh_cart == "yes") {
                  location.reload();
                }
              }
            });
          });
        }
        
        $(".removefromwishlist").click(function () {
          var n = $(this).val();
          q = q.filter(e => e.product_id != n), $.ajax({
            url: zooomListUrl + "remove-product",
            data: {
              shop: e,
              productid: n,
              customerid: t
            },
            dataType: "json",
            type: "post",
            async: "true",
            success: function (e) {
              pid = e.productid, $("#ZoomyWishlistPageGrid-" + pid).remove(), $("#ZoomyWishlistPagecol-" + pid).remove()
            }
          }), R = JSON.stringify(q), localStorage.setItem("myzooomy__wishlist", R), $("#zooomy-wishlist-counter").length && (document.getElementById("zooomy-wishlist-counter").innerHTML = $(".ZoomyWishlistPageGrid").length - 1)
          if (a.length <= 1) {
            $("#ZoomyWishlistPage").append("<p class='zmsg s-account__history-empty'>It is empty here. <br>Personalize your shopping experience with your Favorites. <a class='s-account__history-empt-link' href='/'>Shop Now</a></p>")
          }
        }), $("#emailzwishlist").click(function () {
          $("#zemaildata").slideToggle("100")
        }), $("#zsendemail").click(function () {
          var n = $("#zemailid").val(),
            i = $("#zemailname").val(),
            o = $("#zemailmsg").val();
          if ("" == i && $("#zemaildata form").prepend("<span style='float:left;width:100%;padding:2px 0px;' class='zaddwsubject'>Add Subject.</span>"), "" == n && $("#zemaildata form").prepend("<span style='float:left;width:100%;padding:2px 0px;' class='zaddwemail'>Add Email address.</span>"), "" != n && "" != i) {
            var r = t;
            $.ajax({
              url: "https://zooomyapps.com/wishlist/ZooomyEmailList.php?shop=" + e + "&getcusid=" + r + "&zemailid=" + n,
              data: {
                shop: e,
                getcusid: r,
                zemailid: n,
                zemailname: i,
                zemailmsg: o
              },
              dataType: "jsonp",
              jsonp: "jsonDataCode",
              async: "true",
              success: function (e) {
                e.emailed
              }
            }), $("#zemaildata").slideToggle("100"), $("#emailzwishlist").before("<span class='emailsentz'>Email has been sent</span>")
          }
        }), $(".zooomylink_fa").click(function () {
          $("#zooomycopytxtarea").fadeIn(1e3), setTimeout(function () {
            $("#zooomycopytxtarea").fadeOut(400)
          }, 15e3)
        }), "false" != k && "" != t || $("#zooomyemailfbtn").on("mouseover", function () {
        }), $("<style>" + o + "</style>").appendTo("body"), $("#zooomy-wishlist-counter").length && (numItems = $(".ZoomyWishlistPageGrid").length, document.getElementById("zooomy-wishlist-counter").innerHTML = numItems)
        setTimeout(function () {
          const account = $('.s-account');
          account.removeClass('is-loaded');
          account.removeClass('is-loaded-overview');
        }, 300);
      } else {
        $("#ZoomyWishlistPage").append("<p class='zmsg s-account__history-empty'>It is empty here. <br>Personalize your shopping experience with your Favorites. <a class='s-account__history-empt-link' href='/'>Shop Now</a></p>")
        if (!guestCart.length) {
          const account = $('.s-account');
          setTimeout(function () {
            account.removeClass('is-loaded');
            account.removeClass('is-loaded-overview');
          }, 300);
        }
      }
    }
  });
}

function unescapeHtml(str) {
  return str
    .replace(/&/g, "&amp;")
    .replace(/'/g, "&#39;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

/**
 * Get currency symbol from a currency code & locale.
 * @param {string} currencyCode - e.g. "USD", "EUR", "JPY"
 * @param {string} locale - optional, defaults to browser locale
 */
function getCurrencySymbol(currencyCode, locale = undefined) {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode,
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: 0
  })
    .formatToParts(1)
    .find(part => part.type === 'currency').value;
}

ZooomyDataFun(shop, customerid, customeremail);
